// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/Container.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#main {
  background: linear-gradient(rgba(0, 0, 0, 0.5),
      rgba(0, 0, 0, 0.5)),
    url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-blend-mode: darken;
}


* {
  font-family: Netflix Sans, Helvetica Neue, Segoe UI, Roboto, Ubuntu, sans-serif;
}

body {
  min-height: 100vh;
  background-color: rgba(0, 0, 0, 1);
}

body,
h1,
h2,
h3,
h4,
h5,
h6,
p {
  font-family: Netflix Sans, Helvetica Neue, Segoe UI, Roboto, Ubuntu, sans-serif;
}

.min-hbody-full {
  height: calc(100vh - 160px);
}

button:disabled,
input:disabled {
  opacity: .5;
  cursor: not-allowed;
}

.scrollbar-hide::-webkit-scrollbar {
  display: none;
}

.bg-gradient {
  background: linear-gradient(to right, #383737, #6a6a6a, #3d3434);
}

.vjs_video_3-dimensions.vjs-fluid:not(.vjs-audio-only-mode) {
  padding: 0;
}

.vjs-fluid:not(.vjs-audio-only-mode) {
  padding-top: 0;
}

.video-js .vjs-control-bar {
  background: none !important;
}

.video-js.vjs-logo .vjs-logo-content.vjs-logo-hide {
  visibility: visible !important;
  opacity: 0.5 !important;
}

/* @media (max-width: 480px) { 
  .video-js.vjs-logo .vjs-logo-content.vjs-logo-hide {
    width: 15% !important; 
    height: auto;
  } */
/* .video-js.vjs-fluid:not(.vjs-audio-only-mode),
  .video-js.vjs-16-9:not(.vjs-audio-only-mode),
  .video-js.vjs-4-3:not(.vjs-audio-only-mode),
  .video-js.vjs-9-16:not(.vjs-audio-only-mode),
  .video-js.vjs-1-1:not(.vjs-audio-only-mode) {
    height: 32vh !important; 
  } */
/* } */

/* .video-js.vjs-fluid:not(.vjs-audio-only-mode), 
.video-js.vjs-16-9:not(.vjs-audio-only-mode), 
.video-js.vjs-4-3:not(.vjs-audio-only-mode), 
.video-js.vjs-9-16:not(.vjs-audio-only-mode), 
.video-js.vjs-1-1:not(.vjs-audio-only-mode) {
  height: 111vh !important; 
    max-height: 640px;
} */

#video-padding>.video-js {
  padding-top: 0px !important;
  height: 640px;
}

@media (max-width: 768px) {
  #video-padding>.video-js {
    height: 220px;
  }

  .video-js.vjs-logo .vjs-logo-content.vjs-logo-hide {
    width: 15% !important;
    height: auto;
  }
}

.searchbox-container div.absolute {
  right: 0;
  min-width: 200px;
}

.text-w2w-600 svg {
  color: red;
}

.custom-w2w {
  background-color: #883cae;
}

.react-code-input input::-webkit-outer-spin-button,
.react-code-input input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.react-code-input {
  text-align: center;
}

.react-code-input input {
  background-color: transparent !important;
  color: #fff !important;
  -moz-appearance: textfield !important;
  font-size: 1rem !important;
  text-align: center;
  padding: 0 !important;
}

.no-scrollbar {
  scrollbar-width: none;
  /* For Firefox */
  -ms-overflow-style: none;
  /* For IE and Edge */
}

.no-scrollbar::-webkit-scrollbar {
  display: none;
  /* For Chrome, Safari, and Opera */
}

.main-slider-shadow {
  background: linear-gradient(to right, rgb(0 0 0) 0%, rgba(255, 255, 255, 0) 35%)
}

@media (min-width: 1200px) {
  .react-multi-carousel-track li:after {
    content: " ";
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    background-color: rgba(0, 0, 0, .25);
  }
}

.react-multiple-carousel__arrow--left {
  left: calc(1% + 1px) !important;
}

.react-multiple-carousel__arrow--right {
  right: calc(1% + 1px) !important;
}

@keyframes rotating {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.rotating {
  animation: rotating 2s linear infinite;
}

.multi-line-ellipsis {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  line-clamp: 2;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1;
  max-height: 29px;
}

.PhoneInputInput {
  background-color: #000;
  padding: 14px;
  border: 1px solid #fff;
}

.videojs-ads-info {
  position: absolute;
  right: 0;
  bottom: 50px;
  cursor: pointer;
  display: none;
}

.videojs-ads-info.enabled{
  display: block;
}

.customdots {
    position: absolute;
    right: 18px;
    z-index: 100;
    bottom: 40px;
}

.main-image-wrapper {
  background-size: cover;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE;;2CAE+B;EAC/B,6BAA6B;AAC/B;;;AAGA;EACE,+EAA+E;AACjF;;AAEA;EACE,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;;;;;;;;EAQE,+EAA+E;AACjF;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gEAAgE;AAClE;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;;;;KAIK;AACL;;;;;;KAMK;AACL,MAAM;;AAEN;;;;;;;GAOG;;AAEH;EACE,2BAA2B;EAC3B,aAAa;AACf;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,qBAAqB;IACrB,YAAY;EACd;AACF;;AAEA;EACE,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;EACxC,sBAAsB;EACtB,qCAAqC;EACrC,0BAA0B;EAC1B,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE;AACF;;AAEA;EACE;IACE,YAAY;IACZ,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,WAAW;IACX,YAAY;IACZ,UAAU;IACV,oCAAoC;EACtC;AACF;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;AAClC;;AAmBA;EACE;IAKE,uBAAuB;EACzB;;EAEA;IAKE,yBAAyB;EAC3B;AACF;;AAEA;EAKE,sCAAsC;AACxC;;AAEA;EACE,oBAAoB;EACpB,4BAA4B;EAC5B,aAAa;EACb,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,YAAY;AAChB;;AAEA;EACE,sBAAsB;AACxB","sourcesContent":["#main {\r\n  background: linear-gradient(rgba(0, 0, 0, 0.5),\r\n      rgba(0, 0, 0, 0.5)),\r\n    url(\"./assets/Container.png\");\r\n  background-blend-mode: darken;\r\n}\r\n\r\n\r\n* {\r\n  font-family: Netflix Sans, Helvetica Neue, Segoe UI, Roboto, Ubuntu, sans-serif;\r\n}\r\n\r\nbody {\r\n  min-height: 100vh;\r\n  background-color: rgba(0, 0, 0, 1);\r\n}\r\n\r\nbody,\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5,\r\nh6,\r\np {\r\n  font-family: Netflix Sans, Helvetica Neue, Segoe UI, Roboto, Ubuntu, sans-serif;\r\n}\r\n\r\n.min-hbody-full {\r\n  height: calc(100vh - 160px);\r\n}\r\n\r\nbutton:disabled,\r\ninput:disabled {\r\n  opacity: .5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.scrollbar-hide::-webkit-scrollbar {\r\n  display: none;\r\n}\r\n\r\n.bg-gradient {\r\n  background: linear-gradient(to right, #383737, #6a6a6a, #3d3434);\r\n}\r\n\r\n.vjs_video_3-dimensions.vjs-fluid:not(.vjs-audio-only-mode) {\r\n  padding: 0;\r\n}\r\n\r\n.vjs-fluid:not(.vjs-audio-only-mode) {\r\n  padding-top: 0;\r\n}\r\n\r\n.video-js .vjs-control-bar {\r\n  background: none !important;\r\n}\r\n\r\n.video-js.vjs-logo .vjs-logo-content.vjs-logo-hide {\r\n  visibility: visible !important;\r\n  opacity: 0.5 !important;\r\n}\r\n\r\n/* @media (max-width: 480px) { \r\n  .video-js.vjs-logo .vjs-logo-content.vjs-logo-hide {\r\n    width: 15% !important; \r\n    height: auto;\r\n  } */\r\n/* .video-js.vjs-fluid:not(.vjs-audio-only-mode),\r\n  .video-js.vjs-16-9:not(.vjs-audio-only-mode),\r\n  .video-js.vjs-4-3:not(.vjs-audio-only-mode),\r\n  .video-js.vjs-9-16:not(.vjs-audio-only-mode),\r\n  .video-js.vjs-1-1:not(.vjs-audio-only-mode) {\r\n    height: 32vh !important; \r\n  } */\r\n/* } */\r\n\r\n/* .video-js.vjs-fluid:not(.vjs-audio-only-mode), \r\n.video-js.vjs-16-9:not(.vjs-audio-only-mode), \r\n.video-js.vjs-4-3:not(.vjs-audio-only-mode), \r\n.video-js.vjs-9-16:not(.vjs-audio-only-mode), \r\n.video-js.vjs-1-1:not(.vjs-audio-only-mode) {\r\n  height: 111vh !important; \r\n    max-height: 640px;\r\n} */\r\n\r\n#video-padding>.video-js {\r\n  padding-top: 0px !important;\r\n  height: 640px;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  #video-padding>.video-js {\r\n    height: 220px;\r\n  }\r\n\r\n  .video-js.vjs-logo .vjs-logo-content.vjs-logo-hide {\r\n    width: 15% !important;\r\n    height: auto;\r\n  }\r\n}\r\n\r\n.searchbox-container div.absolute {\r\n  right: 0;\r\n  min-width: 200px;\r\n}\r\n\r\n.text-w2w-600 svg {\r\n  color: red;\r\n}\r\n\r\n.custom-w2w {\r\n  background-color: #883cae;\r\n}\r\n\r\n.react-code-input input::-webkit-outer-spin-button,\r\n.react-code-input input::-webkit-inner-spin-button {\r\n  -webkit-appearance: none;\r\n  margin: 0;\r\n}\r\n\r\n.react-code-input {\r\n  text-align: center;\r\n}\r\n\r\n.react-code-input input {\r\n  background-color: transparent !important;\r\n  color: #fff !important;\r\n  -moz-appearance: textfield !important;\r\n  font-size: 1rem !important;\r\n  text-align: center;\r\n  padding: 0 !important;\r\n}\r\n\r\n.no-scrollbar {\r\n  scrollbar-width: none;\r\n  /* For Firefox */\r\n  -ms-overflow-style: none;\r\n  /* For IE and Edge */\r\n}\r\n\r\n.no-scrollbar::-webkit-scrollbar {\r\n  display: none;\r\n  /* For Chrome, Safari, and Opera */\r\n}\r\n\r\n.main-slider-shadow {\r\n  background: linear-gradient(to right, rgb(0 0 0) 0%, rgba(255, 255, 255, 0) 35%)\r\n}\r\n\r\n@media (min-width: 1200px) {\r\n  .react-multi-carousel-track li:after {\r\n    content: \" \";\r\n    position: absolute;\r\n    left: 0;\r\n    top: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    z-index: 1;\r\n    background-color: rgba(0, 0, 0, .25);\r\n  }\r\n}\r\n\r\n.react-multiple-carousel__arrow--left {\r\n  left: calc(1% + 1px) !important;\r\n}\r\n\r\n.react-multiple-carousel__arrow--right {\r\n  right: calc(1% + 1px) !important;\r\n}\r\n\r\n@-webkit-keyframes rotating\r\n\r\n/* Safari and Chrome */\r\n  {\r\n  from {\r\n    -webkit-transform: rotate(0deg);\r\n    -o-transform: rotate(0deg);\r\n    transform: rotate(0deg);\r\n  }\r\n\r\n  to {\r\n    -webkit-transform: rotate(360deg);\r\n    -o-transform: rotate(360deg);\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n@keyframes rotating {\r\n  from {\r\n    -ms-transform: rotate(0deg);\r\n    -moz-transform: rotate(0deg);\r\n    -webkit-transform: rotate(0deg);\r\n    -o-transform: rotate(0deg);\r\n    transform: rotate(0deg);\r\n  }\r\n\r\n  to {\r\n    -ms-transform: rotate(360deg);\r\n    -moz-transform: rotate(360deg);\r\n    -webkit-transform: rotate(360deg);\r\n    -o-transform: rotate(360deg);\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n.rotating {\r\n  -webkit-animation: rotating 2s linear infinite;\r\n  -moz-animation: rotating 2s linear infinite;\r\n  -ms-animation: rotating 2s linear infinite;\r\n  -o-animation: rotating 2s linear infinite;\r\n  animation: rotating 2s linear infinite;\r\n}\r\n\r\n.multi-line-ellipsis {\r\n  display: -webkit-box;\r\n  -webkit-box-orient: vertical;\r\n  line-clamp: 2;\r\n  -webkit-line-clamp: 2;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  line-height: 1;\r\n  max-height: 29px;\r\n}\r\n\r\n.PhoneInputInput {\r\n  background-color: #000;\r\n  padding: 14px;\r\n  border: 1px solid #fff;\r\n}\r\n\r\n.videojs-ads-info {\r\n  position: absolute;\r\n  right: 0;\r\n  bottom: 50px;\r\n  cursor: pointer;\r\n  display: none;\r\n}\r\n\r\n.videojs-ads-info.enabled{\r\n  display: block;\r\n}\r\n\r\n.customdots {\r\n    position: absolute;\r\n    right: 18px;\r\n    z-index: 100;\r\n    bottom: 40px;\r\n}\r\n\r\n.main-image-wrapper {\r\n  background-size: cover;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
